import React, { useState, useEffect } from "react";
import axios from "axios";
import style from "./SupplierManagement.module.css";
import { Supplier_api } from "../../Apiconfig";
import AddSupplier from "./Add_supplier/AddSupplier";
import AddSupplierOrder from "./Add_supplier_order/AddSupplierOrder";

export default function SupplierManagement() {

  const [showForm, setShowForm] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeSupplier, setActiveSupplier] = useState(null); // To track selected supplier
  const [page, setPage] = useState(1); // To track selected supplier

  const [isEditing, setIsEditing] = useState(false);
  const [editedSupplier, setEditedSupplier] = useState({ ...activeSupplier });
  const [error, setError] = useState("");

  // Fetch suppliers from the backend
  const fetchSuppliers = async () => {
    try {
      const response = await axios.get(`${Supplier_api}show_supplier.php`, {
        withCredentials: true,
      });
      setSuppliers(response.data);
      setPage(page + 1);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  // Handle input changes and update the state
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedSupplier((prev) => ({ ...prev, [name]: value }));
  };

  // Save changes to the database
  const saveChanges = async () => {
    try {
      const response = await axios.post(
        `${Supplier_api}update_supplier.php`,
        editedSupplier,
        {
          withCredentials: true,
        }
      );
      console.log(editedSupplier);
      console.log(response.data);

      if (response.data.success) {
        alert("Customer updated successfully!");
        setIsEditing(false); // Exit edit mode
      } else {
        setError(response.data.error || "Failed to update customer.");
      }
    } catch (error) {
      console.error("Error updating customer:", error);
      setError("An error occurred while updating the customer.");
    }
  };

  // Cancel changes and revert to the original customer data
  const cancelChanges = () => {
    setEditedSupplier({ ...activeSupplier }); // Revert to original values
    setIsEditing(false); // Exit edit mode
  };

  // functions for suppliers details option

  const [activeTab, setActiveTab] = useState("profile"); // Default view is 'profile'



  const [Suppliertransaction, setSuppliertransaction] = useState([]); // Customer transaction history list state


  const fetchSuppliertransaction = async () => {
    try {
      const response = await axios.get(
        `${Supplier_api}Show_supplier_transaction.php`,
        {
          withCredentials: true,
        }
      );
      if (Array.isArray(response.data)) {
        setSuppliertransaction(response.data); // Update customers state
      } else {
        console.error("Unexpected API response:", response.data);
        alert(response.data.message || "Error fetching customers.");
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      alert("An error occurred while fetching the customer list.");
    }
  };

  // Order History
  const [SupplierOrderHistory, setSupplierOrderHistory] = useState([]); // Customer transaction history list state

  const fetchSupplierOrderHistory = async () => {
    try {
      const response = await axios.get(
        `${Supplier_api}show_supplier_order_history.php?supplier_ID=${activeSupplier.id}`,
        {
          withCredentials: true,
        }
      );
      if (Array.isArray(response.data)) {
        setSupplierOrderHistory(response.data);
      } else {
        console.error("Unexpected API response:", response.data);
        alert(response.data.message || "Error fetching customers.");
      }
    } catch (error) {
      console.error("Error fetching order history:", error);
      alert("An error occurred while fetching the order history.");
    }
  };


  const [order, setOrder] = useState([]);
  const [orderItems, setOrderItems] = useState([]);

  const getOrderDetails = async (order) => {
    try {
      const response = await axios.get(
        `${Supplier_api}getOrderDetails.php?Order=${order}&supplierID=${activeSupplier.id}`,
        { withCredentials: true }
      );
      if (response.status === 200) {
        setOrder(response.data.order);
        setOrderItems(response.data.orderItems);
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <div className={style.container}>
      <div className="row align-items-center m-0">
        <div className="col-md-4 text-center">
          <h2 className={style.title}>Supplier Management</h2>
        </div>
        <div className="col-md-4 text-center">
          <button
            onClick={() => setShowForm(!showForm)}
            className={style.toggleButton}
          >
            {showForm ? "Close Form" : "Add Supplier"}
          </button>
        </div>
        <div className="col-md-4">
          <div className={style.searchBar}>
            <input
              type="text"
              className={style.searchInput}
              placeholder="Search suppliers by name, city..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className={style.searchButton}>Search</button>
          </div>
        </div>
      </div>

      {/* Add Supplier Form */}
      {showForm && (
        <AddSupplier />
      )}

      {/* Supplier List or Details View */}
      {!activeSupplier ? (
        <div className={style.supplierTableContainer}>
          <h4>Suppliers List:</h4>
          <table className={style.supplierTable}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Contact</th>
                <th>Shop Name</th>
                <th>City</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.length > 0 ? (
                suppliers.map((supplier) => (
                  <tr
                    key={supplier.id}
                    onClick={() => {
                      setActiveSupplier(supplier);
                      setEditedSupplier({
                        ...supplier,
                        id: supplier.id,
                      });
                      setActiveTab("profile");
                    }}
                  >
                    <td>{supplier.supplier_name}</td>
                    <td>{supplier.contact}</td>
                    <td>{supplier.shop_name}</td>
                    <td>{supplier.city}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No Suppliers found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        // view details section

        <div className={`container-fluid ${style.supplierDetailContainer}`}>
          {/* design for switching */}

          <div className="row justify-content-center align-items-start">


            {/* left side buttons */}

            <div className="col-md-3 text-center">
              <button
                className={style.goBackButton}
                onClick={() => {
                  setActiveSupplier(null);
                  setActiveTab("Profile");
                }}
              >
                <i className="fa-solid fa-arrow-left"></i> Go Back
              </button>
              <div className={style.supplierData}>
                <h4>{activeSupplier.supplier_name}</h4>
                <h4>Contact: {activeSupplier.contact}</h4>
              </div>

              <div className={style.buttonGroup}>
                <button
                  className={style.actionButton}
                  onClick={() => setActiveTab("profile")}
                >
                  Profile
                </button>
                <button
                  className={style.actionButton}
                  onClick={() => {
                    setActiveTab("order_history");
                    fetchSupplierOrderHistory(); // Trigger the API call
                  }}
                >
                  Order History
                </button>
                {/* <button
                  className={style.actionButton}
                  onClick={() => setActiveTab("ordered_items")}
                >
                  Ordered Items
                </button>

                <button
                  className={style.actionButton}
                  onClick={() => {
                    setActiveTab("transactions");
                    fetchSuppliertransaction(); // Trigger the API call
                  }}
                >
                  Transaction
                </button> */}
              </div>
            </div>

            {/* left side section */}

            <div className="col-md-8">
              {activeTab === "profile" && (
                <div>
                  <h5>Supplier Profile</h5>

                  {isEditing ? (
                    <div className={style.editProfile}>
                      <div>
                        <label>Name:</label>
                        <input
                          type="text"
                          name="supplier_name"
                          value={editedSupplier.supplier_name}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <label>Contact:</label>
                        <input
                          type="text"
                          name="contact"
                          value={editedSupplier.contact}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <label>Email:</label>
                        <input
                          type="text"
                          name="email"
                          value={editedSupplier.email}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <label>Shop Name:</label>
                        <input
                          type="text"
                          name="shop_name"
                          value={editedSupplier.shop_name}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <label>City:</label>
                        <input
                          type="text"
                          name="city"
                          value={editedSupplier.city}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <label>Pincode:</label>
                        <input
                          type="text"
                          name="pincode"
                          value={editedSupplier.pincode}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div>
                        <label>Address:</label>
                        <input
                          type="text"
                          name="supplier_address"
                          value={editedSupplier.supplier_address}
                          onChange={handleInputChange}
                        />
                      </div>
                      <button className={style.editbutton} onClick={saveChanges}>Save Changes</button>
                      <button className={style.editbutton} onClick={cancelChanges}>Cancel</button>
                    </div>
                  ) : (
                    <div className={style.editProfileSection}>
                      <p>
                        <strong>Name:</strong> {activeSupplier.supplier_name}
                      </p>
                      <p>
                        <strong>Contact:</strong> {activeSupplier.contact}
                      </p>
                      <p>
                        <strong>Email:</strong> {activeSupplier.email}
                      </p>
                      <p>
                        <strong>Shop Name:</strong> {activeSupplier.shop_name}
                      </p>
                      <p>
                        <strong>City:</strong> {activeSupplier.city}
                      </p>
                      <p>
                        <strong>Pincode:</strong> {activeSupplier.pincode}
                      </p>
                      <p>
                        <strong>Address:</strong>
                        {activeSupplier.supplier_address}
                      </p>
                      <button className={style.editbutton} onClick={() => setIsEditing(true)}>Edit</button>
                    </div>
                  )}
                  {error && <p style={{ color: "red" }}>{error}</p>}
                </div>
              )}

              {activeTab === "order_history" && (
                <div>
                  <div className="row align-items-center">
                    <div className="col">
                      <h5 className="m-0">Order History</h5>
                    </div>
                    <div className="col-auto">
                      <button data-bs-toggle="modal" data-bs-target="#addSupplierOrder" className={`${style.common_btn}`}><i class="fa-solid fa-plus"></i> Add Order</button>
                    </div>
                  </div>
                  {/* ADD SUPPLIER ORDER MODAL */}
                  <AddSupplierOrder supplierID={activeSupplier.id} />
                  <div className="table-responsive">
                    <table className={`table table-striped mt-1 ${style.tablesss}`}>
                      <thead>
                        <tr className={style.customertablehead_tr}>
                          <th>Order ID</th>
                          <th>Products</th>
                          <th>Amount</th>
                          <th>Paid Amount</th>
                          <th>Dues</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {SupplierOrderHistory.length > 0 ? (
                          SupplierOrderHistory.map((supplierOH) => (
                            <tr
                              key={supplierOH.id}
                              data-bs-toggle="modal"
                              data-bs-target="#supplierOrderDetailModal"
                              onClick={() => {
                                // setSelectedOrder(supplierOH);
                                getOrderDetails(supplierOH.id);
                              }}
                            >
                              <td>{supplierOH.id}</td>
                              <td>{supplierOH.product_quantity}</td>
                              <td>{supplierOH.total_amount}</td>
                              <td>{supplierOH.paid_amount}</td>
                              <td>{supplierOH.dues}</td>
                              <td>{supplierOH.order_status}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6">No Order found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>


                  {/* ORDER DETAILS MODAL */}
                  <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="supplierOrderDetailModal" tabindex="-1" aria-labelledby="supplierOrderDetailModalLabel" aria-hidden="true">
                    <div className={`modal-dialog modal-dialog-centered ${style.addSupplierOrderModal}`}>
                      <div className="modal-content">
                        <div className="modal-header">
                          <h1 className={`modal-title fs-5 ${style.modalHeading}`} id="addSupplierOrderLabel"><i className="fa-solid fa-circle-info"></i> Order Details</h1>
                          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className={`modal-body ${style.addOrderSection}`}>

                          <div className="row mb-3">
                            <div className="col-md-12">
                              <div className={style.orderListSection}>
                                <div className={style.listTitleSection}>
                                  <div className="row m-0 align-items-center justify-content-between">
                                    <div className="col-auto">
                                      <h6 className={`mt-2 ${style.listTitle}`}>Order ID: {order.id} - Items</h6>
                                    </div>
                                    <div className="col-auto">
                                      <h6 className={`mt-2 ${style.listTitle}`}>Items: {order.product_quantity}</h6>
                                    </div>
                                  </div>
                                  <hr className='m-0' />
                                </div>
                                <table className={`${style.orderTable} table table-bordered table-striped table-hover align-middle m-0`}>
                                  <thead>
                                    <tr>
                                      <th scope="col">Product Name</th>
                                      <th scope="col">Estimated Price</th>
                                      <th scope="col">Quantity</th>
                                      <th scope="col">Estimated Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    {orderItems.map((item) => (
                                      <tr key={item.id}>
                                        <td>{item.product_name}</td>
                                        <td>{item.amount}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.amount * item.quantity}</td>
                                      </tr>
                                    ))}

                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <th colSpan={3} className='text-end'>Estimated Order Price</th>
                                      <th>{orderItems.reduce((total, item) => total + item.amount * item.quantity, 0)}</th>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div >

                </div>
              )}

              {activeTab === "ordered_items" && (
                <div>
                  <h5>Ordered Items</h5>
                  <table className={`table table-striped ${style.table}`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>


                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === "transactions" && (
                <div>
                  <h5>Transactions</h5>
                  <table className={`table table-striped ${style.table}`}>
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Transaction ID</th>
                        <th>Total Amount</th>
                        <th>Paid Amount</th>
                        <th>Dues</th>
                        <th>Payment Mode</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Suppliertransaction.length > 0 ? (
                        Suppliertransaction.map((suppliertran) => (
                          <tr
                            key={suppliertran.id}
                          >
                            <td>{suppliertran.order_id}</td>
                            <td>{suppliertran.transaction_id}</td>
                            <td>{suppliertran.total_amount}</td>
                            <td>{suppliertran.paid_amount}</td>
                            <td>{suppliertran.dues}</td>
                            <td>{suppliertran.payment_mode}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">No Transaction found</td>
                        </tr>
                      )}


                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
